export interface PurchaseOrderLineForAllocating {
  id: string;
  purchaseOrderPoAllocationId: string;
  orderNo: number;
  sequence: number;
  orderAndLineNo: string;
  supplierKey: string;
  supplierName: string;
  productKey: string;
  productDescription: string;
  deliveryDate: Date;
  balance: number;
  allocated: number;
  thisAllocation: number;
  selected: boolean;
  canDelete: boolean;
}
